export const getLink = (web) => (web.includes('http') ? web : 'http://' + web);
